import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url,
  canonical,
  type = 'website',
  jsonLd 
}) => {
  const siteTitle = "MCO Ride";
  const siteDescription = "Premium transportation to Orlando International Airport (MCO), Disney World, Universal Studios, SeaWorld, and Kissimmee Executive Airport. Professional chauffeur service for Orlando tourists and theme park visitors.";
  const siteUrl = "https://mcoride.com";
  const defaultImage = `${siteUrl}/images/logo.png`;

  const seoTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} - Orlando Airport & Theme Park Transportation`;
  const seoDescription = description || siteDescription;
  const seoImage = image || defaultImage;
  const seoUrl = url || siteUrl;
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : seoUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:site_name" content={siteTitle} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={seoTitle} />
      <meta property="twitter:description" content={seoDescription} />
      <meta property="twitter:image" content={seoImage} />

      {/* JSON-LD structured data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
